<div class="principal-container">
  <div class="close-img-container">
    <img src="../../../../../../../../assets/icons/x.svg" alt="close" (click)="closeModal()">
  </div>

  <div class="content-title">
    {{'SERVICE_SUCCESS_MODAL.0' | translate}}
  </div>
  <div class="content-description">
    {{'SERVICE_SUCCESS_MODAL.1' | translate}}
  </div>
  <div class="button-black" style="margin-top: 26px;" (click)="goToDetails()">
    {{'SERVICE_SUCCESS_MODAL.2' | translate}}
  </div>
</div>